import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getExcusalCountQuery,
  getStudentAllExcusalQuery,
  getHomeroomTeacherResponsibleV2Query,
  getStudentsWithoutHomeroomQuery,
  getOrganizationAllCoursesQuery,
  getHomeroomStudentsCountQuery,
  getCourseMarkedExcusalsQuery,
  getHomeroomStudentsQuery,
  getStudentsCountQuery,
  getStaffListQuery,
} from "Homeroom/modules/HomeroomQueries";

export const getExcusalCountFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getExcusalCountQuery,
      variables,
    });
  } catch (err) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getStudentsCountFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentsCountQuery,
      variables,
    });
  } catch (err) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getStudentAllExcusalFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentAllExcusalQuery,
      variables: variables,
    });
  } catch (err) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getHomeroomTeacherResponsibleV2FromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getHomeroomTeacherResponsibleV2Query,
      variables: variables,
    });
  } catch (err) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getStudentsWithoutHomeroomFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentsWithoutHomeroomQuery,
      variables: variables,
    });
  } catch (err) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getOrganizationAllCoursesFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationAllCoursesQuery,
      variables: variables,
    });
  } catch (err) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getHomeroomStudentsCountFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getHomeroomStudentsCountQuery,
      variables: variables,
    });
  } catch (err) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getHomeroomStudentsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getHomeroomStudentsQuery,
      variables: variables,
    });
  } catch (err) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getCourseMarkedExcusalsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseMarkedExcusalsQuery,
      variables: variables,
    });
  } catch (err) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getStaffListFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStaffListQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return queryData != null ? queryData : {};
};
